var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 43,
    viewBox: "0 0 45 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1542 26.6219C34.5822 27.1762 34.3194 27.9778 34.4497 28.764L36.4129 39.629C36.5786 40.5499 36.1899 41.4818 35.4192 42.014C34.6639 42.5661 33.6592 42.6323 32.8354 42.1907L23.0547 37.0894C22.7146 36.9083 22.337 36.8112 21.9506 36.8001H21.3521C21.1445 36.8311 20.9414 36.8973 20.7559 36.9989L10.9729 42.1244C10.4893 42.3673 9.94165 42.4535 9.40502 42.3673C8.09769 42.12 7.22539 40.8745 7.4396 39.5606L9.40502 28.6955C9.53531 27.9028 9.27252 27.0967 8.70056 26.5336L0.726268 18.8044C0.0593508 18.1574 -0.172524 17.1857 0.132226 16.309C0.428143 15.4345 1.18339 14.7963 2.09543 14.6528L13.0709 13.0605C13.9056 12.9744 14.6388 12.4665 15.0142 11.7157L19.8504 1.80024C19.9653 1.57941 20.1132 1.37624 20.2921 1.20399L20.4909 1.04941C20.5946 0.934576 20.7139 0.839618 20.8464 0.762326L21.0871 0.673993L21.4625 0.519409H22.3922C23.2226 0.605534 23.9535 1.10241 24.3356 1.84441L29.2359 11.7157C29.5892 12.4378 30.276 12.9391 31.0688 13.0605L42.0442 14.6528C42.9717 14.7852 43.7468 15.4257 44.0538 16.309C44.3431 17.1945 44.0935 18.1662 43.4134 18.8044L35.1542 26.6219Z",
    fill: "#FFCE1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.4bdf57140539399abd16c6493c54f454.svg";
export { ForwardRef as ReactComponent };